import { ChangeDetectionStrategy, Component, Input, QueryList, ViewChildren } from '@angular/core';

import { UIService } from '@services';

import { InstallationService } from '../../services/installation.service';
import { FeaturesDetailsOverlayTypeEnum } from '../installation-overlay.model';
import { matTooltipSetter } from 'src/app/shared/functions/mat-tooltip-setter/mat-tooltip-setter';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'app-overlay',
  templateUrl: './overlay.component.html',
  styleUrls: ['./overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverlayComponent {
  featuresDetailsOverlayTypeEnum = FeaturesDetailsOverlayTypeEnum;

  @Input() activeOverlay: FeaturesDetailsOverlayTypeEnum;
  @Input() header: string;
  @Input() toolTipInfo: string;

  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  constructor(public uiService: UIService, private installationService: InstallationService) {}

  close(): void {
    this.restoreMainDeviceSelection();
    this.uiService.closeActiveOverlay();
  }

  blockHorizontalScrolling(): boolean {
    return this.activeOverlay === FeaturesDetailsOverlayTypeEnum.Dhw;
  }

  private restoreMainDeviceSelection(): void {
    if (
      this.activeOverlay !== FeaturesDetailsOverlayTypeEnum.WallboxChargingSettings &&
      this.activeOverlay !== FeaturesDetailsOverlayTypeEnum.WallboxSystem &&
      this.activeOverlay !== FeaturesDetailsOverlayTypeEnum.SolarLog &&
      this.activeOverlay !== FeaturesDetailsOverlayTypeEnum.PvImmersionHeaterDetails &&
      this.activeOverlay !== FeaturesDetailsOverlayTypeEnum.DryContactGenericConsumer
    ) {
      this.installationService.switchSelectionToMainDevice();
    }
  }
}
